/**
 * 原关联项目用医项目
 */

import { createSlice } from '@reduxjs/toolkit';

const commonState = {
    filter: {
        page: 1,
        pageSize: 20,
    },
    cursor: 0,
};

const initialState = {
    project: {
        ...commonState,
        // filter: {
        //     ...commonState.filter,
        //     isTesting: 0,
        // }
    },

    // TODO
};

const medProjectSlice = createSlice({
    name: 'medProject',
    initialState,
    reducers: {
        setProjectFilter: (state, action) => void (state.project.filter = action.payload),
        setProjectCursor: (state, action) => void (state.project.cursor = action.payload),
    },
});

export const medProjectActions = medProjectSlice.actions;

export default medProjectSlice;
